module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"accept":"Принять","cookies-disclaimer":"Пожалуйста, подключите файлы cookies в настройках вашего браузера для корректной работы сервисов сайта."},"en":{"accept":"Accept","cookies-disclaimer":"Please, enable cookies in your browser settings for valid work of site services."}}')
  delete Component.options._Ctor
}
